import { ButtonLink, Icon, IconComponentType, Txt } from '@vst/beam';

import styles from './index.module.scss';

const PrimaryActionCard = ({
  description,
  label,
  icon,
  onClick,
  href = '#',
}: {
  description: string;
  label: string;
  icon: IconComponentType;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  href?: string;
}) => {
  return (
    <div className={styles['action-card']}>
      <Txt variant="bodyLargeRegular">{description}</Txt>
      <div className={styles['primary-action']} onClick={onClick}>
        <ButtonLink href={href} label={label} />
        <Icon icon={icon} color="blue_600" />
      </div>
    </div>
  );
};

export default PrimaryActionCard;
